import { CoachPaymentNote, coachPaymentNoteKind, CoachPaymentNoteToLabel } from '@airreading/common/data';
import { FormCheckboxGroup } from '@/components/forms/form-checkbox-group';
import { FormModal, SubmitProps } from '@/components/form-modal';
import { z } from 'zod';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getCoachPayment, getOngoingPayments, getTotalSumFromLifetime, updatePaymentNotes } from '@/lib/api-calls';
import { FromOptions } from './from-options';

const formSchema = z.object({
  notes: coachPaymentNoteKind.array(),
});

type EditPaymentNoteProps = {
  id: string;
  notes: CoachPaymentNote[];
  from: FromOptions;
};

export const EditPaymentNote = (props: EditPaymentNoteProps) => {
  const { id, from, notes } = props;

  const { mutateAsync } = useMutation({
    mutationFn: updatePaymentNotes,
  });

  const queryClient = useQueryClient();

  const onSubmit = async (values: SubmitProps<z.infer<typeof formSchema>>) => {
    const { formData, closeModal } = values;

    await mutateAsync({ id, data: { notes: formData.notes } });
    if (from === FromOptions.teacherPay) {
      queryClient.invalidateQueries(getOngoingPayments());
    }
    if (from === FromOptions.payments) {
      queryClient.invalidateQueries(getCoachPayment());
    }
    queryClient.invalidateQueries(getTotalSumFromLifetime());
    closeModal();
  };

  return (
    <FormModal
      formSchema={formSchema}
      defaultValues={{ notes: notes }}
      trigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Edit payment note</DropdownMenuItem>}
      modalTitle="Payment note"
      onSubmit={onSubmit}
      confirmBtnLabel="Save"
    >
      {({ form }) => (
        <div className="max-w-lg">
          <FormCheckboxGroup
            form={form}
            name="notes"
            label=""
            options={coachPaymentNoteKind.options}
            optionLabel={(note) => CoachPaymentNoteToLabel[note]}
            horizontal
            labelClassName="text-base"
          />
        </div>
      )}
    </FormModal>
  );
};
